import React from "react";
import Logo from "../components/common/Logo";
import { getIsMobile } from "../utils/responsive";
import { AWS_URL } from "../components/config/constants";

const GuestLayout = ({ children }) => {
  const isMobile = getIsMobile();
  return (
    <div className="main-wrap rc-guest-layout" onContextMenu={(e) => e.preventDefault()}>
      <div className="row" style={{ minHeight: "100vh" }}>
        <div
          className="col-xl-6 d-none d-xl-block p-0 rc-guest-image-panel"
          style={{
            backgroundSize: "cover",
            backgroundPosition: "center",
            backgroundImage: `url(${AWS_URL}logo/login-image.webp)`,
          }}
        >
          <div className="rc-guest-brand">
            <h2>RedCircle</h2>
          </div>
        </div>
        <div
          className="col-xl-6 align-items-center d-flex rounded-3 overflow-hidden bgc-lighter-black-new"
          style={{ background: "var(--rc-bg-secondary)" }}
        >
          <div
            className={`${
              isMobile ? "card" : "card border-r16px radius-16"
            } shadow-none border-0 ms-auto me-auto login-card overflow-scroll-mobile h-auto animate-fade-in`}
          >
            <div className="card-body rounded-0 text-left rc-auth-card">
              <Logo variant="login" centered />
              {children}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GuestLayout;
